module.exports = __webpack_public_path__ + "static/media/decare_logo.340e69f8.png";